<template>
  <div class="space-y-6">
    <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-6">
      <h3 class="text-lg font-medium font-poppins text-gray-900 dark:text-gray-100 mb-4">
        Internal Notes
      </h3>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <UiControl id="internal-account-lead" label="Account Lead">
          <UiSelect
            id="internal-account-lead-select"
            v-model="form.account_lead_id"
            :options="teamMemberOptions"
          />
        </UiControl>
        <UiControl id="internal-priority" label="Onboarding Priority">
          <UiSelect
            id="internal-priority-select"
            v-model="form.onboarding_priority"
            :options="priorityOptions"
          />
        </UiControl>
        <UiControl id="internal-contract-start" label="Contract Start Date">
          <UiInput v-model="form.contract_start_date" type="date" />
        </UiControl>
      </div>
      <div class="mt-4">
        <UiControl id="internal-sales-notes" label="Notes from Sales">
          <UiTextarea v-model="form.notes_from_sales" placeholder="Any relevant notes from the sales process..." />
        </UiControl>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import UiControl from '~/javascript/components/ui/form/control/control.vue'
import UiInput from '~/javascript/components/ui/form/input/input.vue'
import UiSelect from '~/javascript/components/ui/form/select/select.vue'
import UiTextarea from '~/javascript/components/ui/form/textarea/textarea.vue'
import { getTeamMembers } from '~/javascript/api/onboardings'

const props = defineProps({
  stepKey: { type: String, required: true },
  label: { type: String, required: true },
  onboarding: { type: Object, required: true },
  mode: { type: String, required: true }
})

const priorityOptions = [
  { id: 'standard', title: 'Standard (14 days)' },
  { id: 'expedited', title: 'Expedited (7 days)' },
  { id: 'rush', title: 'Rush (3 days)' }
]

const teamMemberOptions = ref([])

const form = ref({
  account_lead_id: '',
  onboarding_priority: '',
  contract_start_date: '',
  notes_from_sales: ''
})

async function loadTeamMembers() {
  try {
    const response = await getTeamMembers()
    teamMemberOptions.value = (response.data || []).map(user => ({
      id: user.id,
      title: user.name
    }))
  } catch (e) {
    console.error('Failed to load team members:', e)
  }
}

onMounted(() => {
  const o = props.onboarding
  form.value.account_lead_id = o.account_lead_id || ''
  form.value.onboarding_priority = o.onboarding_priority || ''
  form.value.contract_start_date = o.contract_start_date || ''
  form.value.notes_from_sales = o.notes_from_sales || ''

  loadTeamMembers()
})

defineExpose({
  getData: () => ({ ...form.value })
})
</script>
